import React from "react";
import Navbar from "../../components/navbar/Navbar";
import BlogDetails from "./BlogDetails";
import "../all css/BlogDetails.css";
import Footer from "../../components/footer/footer";
import InterestedSectionMain from "../../components/interested section/InterestedSectionMain";

export default function Blog() {
  return (
    <div className="blog_main_container">
      <div className="nav_container">
        <Navbar fromPage="blogs" />
      </div>
      <div className="bg_img_blog">
        <BlogDetails />
      </div>
      <InterestedSectionMain />
      <Footer />
    </div>
  );
}
